/* eslint-disable max-lines */
const en = {
  nav: {
    home: "Home",
    drops: "Drops",
    upcomingDrops: "Sales Collection",
    cinema: "Cinema",
    archive: "Sales Archive",
    activeDrops: "Active Drops",
    contact: "Contact",
    signIn: "Sign in",
    apply: "Enter the Collection",
    enterVault: "Enter the Collection",
    signOut: "Sign out",
    hiddenVault: "A Hidden Collection",
    privacy: "Privacy Policy",
  },
  hero: {
    overline: "Est. 2026 — A Hidden Collection",
    headline1: "Garage Drops.",
    headline2: "For those who buy stories, not products.",
    subtitle:
      "A private archive of cinematic objects, restomod legends, and rare collector vehicles. Released without warning. Disappeared without explanation.",
    teaserLabel: "Drop arrives in",
    liveBadge: "Drop live · Members only",
    nextDropPrefix: "Next Drop —",
    viewDrops: "View Drops",
    apply: "Enter the Collection",
    scroll: "Scroll",
  },
  countdown: {
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    live: "Drop is live",
    closes: "Drop Closes In",
    imminent: "Imminent · Announcement coming",
  },
  manifesto: {
    overline: "The Manifesto",
    body:
      "We don't run an auction house. We don't sell to the highest bidder. We release one rare object at a time, and it disappears.",
    pillars: [
      {
        n: "01",
        t: "Curated",
        d: "Every drop is restored, photographed and documented in-house.",
      },
      {
        n: "02",
        t: "Numbered",
        d: "Each object carries a serialised certificate. No reproductions.",
      },
      {
        n: "03",
        t: "Hidden",
        d: "Member-only details surface only after registration.",
      },
    ],
  },
  teaser: {
    overline: "Coming Soon",
    headline: "Something rare is being prepared.",
    body:
      "The next drop is sealed inside the collection. Apply for membership to receive the announcement before anyone else.",
    apply: "Apply for early access",
    signIn: "Sign in",
  },
  cinema: {
    overline: "Cinema · Garage Drops",
    headline: "The Collection, in motion.",
    body:
      "Curated video fragments: behind-the-scenes, restorations, cinematic drives. Selection rotates without warning.",
    publicOverline: "Public reel",
    publicTitle: "Footage open to anyone.",
    exclusiveOverline: "Exclusive Cinema",
    exclusiveTitle: "Only for those who entered the collection.",
    exclusiveLockedHeadline: "There is a second reel, reserved.",
    exclusiveLockedBody:
      "Private drives, technical sessions, unreleased restomods. Enter the collection to unlock everything.",
    exit: "Close",
  },
  contact: {
    overline: "Contact · Garage Drops",
    headline: "Write to us. We reply personally.",
    body:
      "For private enquiries, collaborations, sale and consignment. Every message lands in a single inbox — ours.",
    directOverline: "Direct email",
    directHeadline: "Prefer to write directly?",
    directBody:
      "Your emails land in the same inbox as our private client conversations. We reply within 24 hours.",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    country: "Country",
    message: "Message",
    messagePlaceholder:
      "I'd like information · I'm interested in a drop · I'd like to propose a vehicle of mine...",
    submit: "Send message",
    submitting: "Encrypting…",
    successText: "MESSAGE RECEIVED",
    successSub: "We will reply personally.",
    error: "Could not send. Try again.",
  },
  releases: {
    overline: "Current Releases",
    headline: "Now in the collection.",
    allDrops: "All Drops →",
  },
  membership: {
    overline: "Membership",
    headline: "Some drops are visible only after the door opens.",
    body:
      "Membership is free. Submit your country, choose a passphrase, and unlock the archive — every drop, every story, every photograph.",
    apply: "Enter the Collection",
  },
  drops: {
    overline: "The Collection",
    headline: "Current Drops.",
    subtitle:
      "Each release lives here only briefly. After the countdown ends, the object moves to a private collection or to the archive.",
    empty: "No drops are visible yet. The Collection is between releases.",
    loading: "Loading…",
    membersOnly: "Members Only",
    live: "Live Now",
    unlockingOverline: "Collection Status",
    unlockingHeadline: "Next Garage Drop Unlocking Soon",
    unlockingMystery: "Some doors only open at the right hour.",
    showcaseLabel: "Sales Archives — Curated Anonymously",
  },
  drop: {
    backLink: "Back to drops",
    lockedOverline: "Drop unlocking soon",
    lockedHeadline: "This drop is about to be revealed.",
    lockedBody:
      "Details will appear here the moment the countdown hits zero. Stay close — the collection opens soon.",
    backHome: "Back to home",
    object: "The Object",
    specs: "Specifications",
    gallery: "Gallery",
    story: "The Story",
    restoration: "Restoration",
    restorationHeadline: "Rebuilt section by section.",
    beforeAfter: "Transformation",
    beforeAfterHeadline: "Before. After.",
    before: "Before restoration",
    after: "After restoration",
    notFound: "Drop not found.",
    backToVault: "Back to Collection",
    teaserOverline: "Drop incoming",
    teaserHeadline: "A single clue, for now.",
    teaserBody: "The full drop reveals itself only when it goes live. Stay in the collection — we'll let you know first.",
    price: "Price",
    priceOnRequest: "On request",
    interested: "I'm interested",
    inCatalogOverline: "In catalog",
    inCatalogHeadline: "Currently not for sale.",
    inCatalogBody:
      "Only one piece at a time is officially released through the cinematic drop system. This vehicle lives in the private archive and may return when the signal calls for it.",
    inCatalogMemberBody:
      "This vehicle is not currently for sale but belongs to the private collection. Fill in the form below to request detailed information.",
    inCatalogCta: "Become a member",
    categories: {
      esterno: "Exterior",
      interno: "Interior",
      sx: "Left side",
      dx: "Right side",
      sopra: "Top",
      sotto: "Underside",
      particolari: "Details",
      restauro: "Restoration · Photos & Video",
      video: "Video",
    },
  },
  signalPrivileges: {
    overline: "Member benefits",
    headline: "What you unlock inside the Collection.",
    body: "Become a member to access the entire Sales Collection and request private information on models that aren't currently for sale.",
    items: [
      "Full catalog access",
      "Story, photos and details of every vehicle — even those not for sale",
      "Private inquiries on any model",
    ],
    footer: "Only one piece is officially for sale at a time. The rest lives in the catalog.",
  },
  howItWorks: {
    overline: "How it works",
    headline: "Five steps. One full drop.",
    steps: [
      "A drop is prepared in private.",
      "Members receive the signal first.",
      "The vehicle appears for a limited time.",
      "Negotiations go through the Concierge.",
      "The drop enters the archive and disappears.",
    ],
  },
  experienceTiers: {
    overline: "Access levels",
    headline: "Three doors. Three depths.",
    body: "Garage Drops is not a marketplace. It is a layered collection: most visitors will never see what happens behind the second door.",
    public: {
      title: "Visitor",
      access: "Public access",
      items: [
        "Manifesto and signal newsletter",
        "Public cinematic fragments",
        "Pre-drop clues, never details",
        "No archive, no gallery",
      ],
      footer: "A threshold. Nothing more.",
    },
    members: {
      title: "Collection Member",
      access: "Private access · free",
      items: [
        "Private archive of closed drops",
        "Full gallery, specifications, story",
        "Full cinematic films",
        "Drop notice 24h before publication",
        "Pre-registration to upcoming drops",
      ],
      footer: "Few names. One single signal.",
    },
    concierge: {
      title: "Concierge Channel",
      access: "Activation only",
      items: [
        "Private one-to-one vehicle negotiations",
        "Vehicles never publicly indexed",
        "Bespoke consignment and search",
        "Direct email line to the operator",
        "Timing, budget, trade-in negotiated one by one",
      ],
      footer: "Open the Concierge. Leave a code.",
    },
  },
  archive: {
    overline: "Confidential · Closed archive",
    headline: "Sales Archive.",
    body:
      "Vehicles that passed through the collection and vanished. Stories closed. Transmissions terminated.",
    empty:
      "No closed transmissions yet. Ended signals will appear here.",
    statusLabels: {
      ended: "Signal ended",
      closed: "Transmission closed",
      locked: "Drop locked",
      lost: "Signal lost",
      archived: "Archived",
    },
    whispers: [
      "Signal may return.",
      "Availability status unknown.",
      "Transmission terminated.",
      "Story closed.",
      "No confirmation of return.",
    ],
  },
  auth: {
    loginOverline: "Sign in",
    loginHeadline: "The Collection recognises you.",
    loginBody: "Enter your details to unlock the archive.",
    email: "Email",
    passwordLabel: "Passphrase",
    submitLogin: "Sign In",
    submittingLogin: "Verifying…",
    notMember: "Not yet a member?",
    applyLink: "Enter the Collection",

    registerOverline: "Apply",
    registerHeadline: "Step inside the archive.",
    registerBody: "Membership is free, and it stays that way. Tell us where you are.",
    country: "Country",
    firstName: "First name",
    lastName: "Last name",
    passwordMin: "Passphrase (min 6)",
    privacyConsent1: "I have read and accept the",
    privacyConsentLink: "Privacy Policy",
    privacyConsent2:
      "and consent to the processing of my data under GDPR.",
    submitRegister: "Enter the Collection",
    submittingRegister: "Opening…",
    alreadyMember: "Already inside?",
    signInLink: "Sign in",

    welcomeBack: "Welcome back to the collection.",
    welcomeNew: "Welcome. The Collection is now open.",
    privacyRequired: "You must accept the privacy policy.",
    cannotSignIn: "Could not sign in.",
    cannotRegister: "Could not create account.",
  },
  newsletter: {
    overline: "The Newsletter",
    headline: "Drops are announced before they appear.",
    body:
      "No spam, no marketplace noise. A single, cinematic dispatch when something rare is released.",
    yourEmail: "Your email",
    placeholder: "you@example.com",
    subscribe: "Subscribe",
    submitting: "...",
    success: "You are on the list. Stay near your inbox.",
    fail: "Could not subscribe. Try again.",
  },
  counter: {
    overline: "The Inner Circle",
    membersSuffix: "collectors hold the keys",
  },
  concierge: {
    label: "Concierge",
    labelMember: "Private Concierge",
    open: "Open the Concierge",
    close: "Close",
    title: "Concierge",
    titleMember: "Private Concierge",
    memberBadge: "Collection Member",
    memberWelcome:
      "Welcome back{name}. I'm your private Concierge. I know every drop in the collection — story, restoration, specifications. I can suggest similar vehicles, guide an acquisition, recall our previous conversations. Ask anything.",
    back: "Back",
    continue: "Continue",
    completeFields: "Complete all fields",
    readyToDispatch: "Ready to dispatch",
    phaseLabel: {
      activation: "01 / Activation",
      qualify: "02 / Pre-qualification",
      access: "03 / Collection access",
      dispatch: "04 / Operator handoff",
      chat: "Direct line · Concierge",
      sent: "Transmission sent",
    },
    activationIntro:
      "Select a code. No greetings, no small talk. Only transmissions.",
    codes: {
      inquiry: "Vehicle inquiry",
      consign: "Consign a vehicle to the collection",
      vault: "Private collection access",
      negotiation: "Active private negotiation",
      qa: "Q&A · Open questions about the collection",
      operator: "Direct line to the operator",
    },
    chat: {
      welcome:
        "Open line. Ask anything about the collection — drops, membership, the archive, the manifesto. Short, cinematic replies.",
      intro: "● Q&A · Concierge · Open line",
      introMember: "● Private Concierge · Confidential line",
      placeholder: "Type your question…",
      send: "Send",
      typing: "Composing reply…",
      error:
        "The line is broken. Try again in a moment, or switch to a structured transmission.",
      escalateLabel: "Want to leave a trace with the operator?",
      escalateCta: "Switch to structured request",
      escalateLabelMember: "Ready to move on a specific vehicle?",
      escalateCtaMember: "Open a private negotiation",
      suggestionsPublic: [
        "How does Garage Drops work?",
        "How much is membership?",
        "Can I consign one of my vehicles?",
      ],
      suggestionsMember: [
        "What drops are currently in the collection?",
        "Tell me the story of the Fiat 500 F Restomod",
        "Which vehicles would you recommend for vintage Italian style?",
        "How does the acquisition process work?",
      ],
    },
    fields: {
      name: "Full name",
      email: "Contact email",
      country: "Country",
      timing: "Timing",
      budget: "Budget",
      trade: "Trade-in",
      note: "Private note",
      notePlaceholder:
        "Vehicle of interest, make/model, specific details…",
    },
    timing: {
      now: "Immediate",
      q1: "Within 3 months",
      h1: "Within 6 months",
      open: "Open-ended",
    },
    budget: {
      b1: "Up to €50,000",
      b2: "€50,000 — €150,000",
      b3: "€150,000 — €350,000",
      b4: "€350,000 — €750,000",
      b5: "Above €750,000",
    },
    trade: {
      yes: "Yes",
      no: "No",
      maybe: "Considering",
    },
    access: {
      code: "VAULT",
      headline: "The collection is closed to this identity.",
      body: "To proceed with this code you must first enter the collection. Registration is free, one single passphrase.",
      register: "Enter the Collection",
      login: "I already have access",
    },
    dispatch: {
      id: "Dispatch ID",
      body: "Transmission ready. The operator replies personally, typically within 24 hours.",
      bodyMulti: "Transmission ready. Choose the channel. The operator replies personally, typically within 24 hours.",
      whatsapp: "Send via WhatsApp",
      email: "Send via Email",
      privacy: "Direct email to a private inbox.",
      privacyMulti: "End-to-end encryption via WhatsApp · Direct email to a private inbox.",
    },
    sent: {
      overline: "Transmission sent",
      headline: "The signal has left.",
      body: "The operator will receive your transmission. You'll be contacted personally, in private.",
      reset: "New transmission",
    },
  },
  intro: {
    line1: "Accessing private network",
    line2: "Opening the collection",
    lineGlitch: "// SIGNAL // SIGNAL //",
    skip: "Skip",
    label: "Garage Drops · Restricted Access",
    check1: "Secure link",
    check2: "Visitor identification",
    check3: "Archive unlock",
    granted: "ACCESS GRANTED",
    welcome: "Welcome to the Collection",
  },
  signal: {
    overline: "Private Signal",
    headline: "A single transmission, when something rare is released.",
    body: "No marketplace noise. No spam. Drops are announced here before they appear anywhere else.",
    placeholder: "your@private.email",
    submit: "Join the signal",
    submitting: "Transmitting…",
    successText: "TRANSMISSION RECEIVED",
    successSub: "Stay near your inbox.",
    error: "Could not join. Try again.",
    explainerLabel: "What happens when you join",
    explainer1: "Email only — no account, no password.",
    explainer2: "A single transmission 24h before each drop.",
    explainer3: "Zero spam. Unsubscribe in one click.",
  },
  offer: {
    overline: "Private Request",
    signedInOverline: "● Signed in as",
    useOtherEmail: "Use other email",
    useMyData: "Use my account",
    headline: "Interested? Leave a trace.",
    body: "Tell us who you are and what you'd like to know — price, condition, availability. We will contact you personally, in private.",
    firstName: "First name",
    lastName: "Last name",
    name: "Name",
    email: "Email",
    country: "Country",
    phone: "Phone (optional)",
    amount: "Offer amount",
    message: "Your message",
    messagePlaceholder: "I'd like to know the price · I'm interested in a private viewing · Please send more information about...",
    submit: "I'm interested",
    submitting: "Encrypting…",
    privacyNote: "Encrypted · Personal reply within 24h",
    successText: "REQUEST RECEIVED",
    successSub: "An agent will contact you shortly.",
    error: "Could not submit. Try again.",
  },
  presentation: {
    featuredOverline: "Current Drop",
    liveNow: "Live Now",
    countdownLabel: "Drop closes in",
    viewFullDrop: "View Full Drop",
    apply: "Enter the Collection",
    objectOverline: "The Object",
    galleryOverline: "Gallery",
    specsOverline: "Specifications",
    storyOverline: "The Story",
    closingLine: "When the timer ends, this object disappears.",
    lockedHeadline: "This drop is sealed.",
    lockedBody:
      "Apply for membership to unlock the photographs, the specifications, and the story behind this object.",
    archiveLinkOverline: "Archive",
    archiveLinkBody: "See the drops that already moved into private collections →",
  },
  footer: {
    description:
      "A hidden digital collection for rare automotive and cinematic collector drops.",
    navigateOverline: "Navigate",
    legalOverline: "Legal",
    legal: {
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      terms: "Terms of Service",
    },
    nav: {
      home: "Home",
      drops: "Current Drops",
      archive: "Archive",
      register: "Enter the Collection",
      signIn: "Sign In",
    },
    rights: "© {year} Garage Drops",
    tagline: "The Collection opens at sundown",
    disclaimer:
      "Item from my personal private collection. Private sale. Sold as seen, with no warranty or returns.",
  },
  privacy: {
    overline: "Legal",
    title: "Privacy Policy",
    updated:
      "Last updated: February 2026 · Compliant with EU GDPR (Reg. 2016/679) and Italian D.Lgs. 196/2003.",
    s1Title: "1. Data Controller",
    s1Body:
      "Garage Drops (the \"Platform\") is the controller of personal data collected via this website. For any questions concerning your data, contact us at",
    s2Title: "2. Data We Collect",
    s2Intro: "We process the following categories of data:",
    s2List: [
      "Account data — email address, hashed passphrase, country.",
      "Newsletter subscription — email address, country (optional), timestamp.",
      "Technical data — IP address, user agent, basic logs (retained max 90 days).",
    ],
    s3Title: "3. Legal Basis & Purpose",
    s3Body:
      "We process your data on the legal bases of: (a) contractual necessity — to provide membership and access to drops; (b) consent — for newsletter subscription, withdrawable at any time; and (c) legitimate interest — for fraud prevention and platform integrity.",
    s4Title: "4. Cookie Policy",
    s4Body:
      "Garage Drops uses only strictly necessary cookies (httpOnly authentication cookie). No third-party tracking, advertising, or analytics cookies are deployed.",
    s5Title: "5. Data Retention",
    s5Body:
      "Account data is retained for as long as your membership is active and for 24 months after deletion request, for legal recordkeeping. Newsletter data is retained until you unsubscribe. Technical logs are retained for 90 days.",
    s6Title: "6. Data Sharing",
    s6Body:
      "We do not sell your data. We share it only with sub-processors strictly necessary to operate the platform: cloud hosting (data within EU), email delivery (Resend, EU/US with Standard Contractual Clauses), and object storage (within the Emergent platform infrastructure).",
    s7Title: "7. Your Rights (Art. 15-22 GDPR)",
    s7Intro: "You have the right to:",
    s7List: [
      "Access your personal data and obtain a copy.",
      "Request rectification of inaccurate data.",
      "Request erasure (right to be forgotten).",
      "Restrict or object to processing.",
      "Data portability.",
      "Withdraw consent at any time, without affecting prior lawfulness.",
      "Lodge a complaint with the Italian Data Protection Authority.",
    ],
    s7Outro: "To exercise any of these rights, write to",
    s8Title: "8. Security",
    s8Body:
      "Passphrases are stored hashed with bcrypt. Communications happen over HTTPS. Authentication tokens live in httpOnly Secure cookies. Access to administrative tools is gated behind authentication and a hidden route.",
    s9Title: "9. Terms of Service",
    s9Body:
      "By using the Platform you agree to these terms. Membership is offered free of charge and may be revoked at our discretion in case of misuse. All drops, photographs, and editorial content remain the property of Garage Drops or the original artisans, restorers and photographers credited.",
    s10Title: "10. Changes to this Policy",
    s10Body:
      "We may update this Privacy Policy from time to time. We will notify members by email of any material change.",
  },
  upcoming: {
    overline: "Private Collection",
    headline: "Sales Collection.",
    subtitle:
      "The complete private collection. Only one vehicle at a time is officially for sale; the rest stay in the catalog. Members can request information on any model.",
    empty: "The catalog is being built. Watch this page.",
    locked: "Locked",
    filterAll: "All",
    filterAuto: "Auto",
    filterMoto: "Moto",
  },
  quickInquiry: {
    overline: "Quick inquiry",
    headline: "Have a question? Write to us.",
    body: "No sign-up required. A short note — we reply in private.",
    name: "Name",
    email: "Email",
    message: "Your message",
    send: "Send inquiry",
    sent: "Inquiry sent. We will reply shortly.",
    error: "Send failed. Please try again.",
    memberHook: "Want to see the full catalog?",
    memberCta: "Become a member — full Collection access",
  },
  welcome: {
    overline: "Welcome",
    headline: "What Garage Drops is.",
    body1:
      "Garage Drops is a private collection of rare cars and rare motorcycles, restored and hand-picked — from my own collection and from carefully selected private collections.",
    body2:
      "Each vehicle is presented through a dedicated cinematic release. Only one vehicle at a time is officially for sale; the others are kept inside the Collection.",
    body3:
      "Before publishing, every vehicle is inspected and road-tested. When a fully documented restoration is not available, the vehicle is still checked and tested by us and by our authorized workshop, to guarantee proper operation and full transparency toward the future owner.",
    body4:
      "Private sale: every vehicle comes from my personal collection or from carefully selected private collections, and is sold as seen, with no warranty or returns.",
    languageLabel: "Language",
    privacyPrefix: "By continuing you acknowledge our",
    privacyLink: "Privacy Policy",
    continue: "Enter the Collection",
  },
};

export default en;
